import React from "react";
import { CheckCircle2, Phone } from "lucide-react";
import { BUSINESS } from "../../lib/constants";

export const QuoteSuccess = ({ onReset }) => (
  <div
    data-testid="quote-success"
    className="flex flex-col items-center text-center py-16"
  >
    <div className="h-20 w-20 bg-gold border-2 border-navy flex items-center justify-center">
      <CheckCircle2 className="h-10 w-10 text-navy" strokeWidth={2.5} />
    </div>
    <h3 className="mt-6 font-display uppercase text-3xl text-navy">
      Quote request received!
    </h3>
    <p className="mt-3 text-navy/75 max-w-md">
      Thanks — we'll reach out shortly. Need same-day help?
    </p>
    <a
      href={BUSINESS.phoneHref}
      className="brutal-btn mt-6 inline-flex items-center gap-2 bg-gold text-navy px-6 py-3 font-display uppercase tracking-wider border-2 border-navy"
    >
      <Phone className="h-4 w-4" strokeWidth={3} />
      Call {BUSINESS.phoneDisplay}
    </a>
    <button
      type="button"
      onClick={onReset}
      className="mt-8 text-sm text-navy/60 underline"
    >
      Submit another request
    </button>
  </div>
);
